import React from "react";
import { useReceiptCardInfo } from "../handlers/useReceiptCardInfo";

interface DriverInfoProps {
  driverPhone: string;
  data: any;
}
const DriverInfo: React.FC<DriverInfoProps> = ({ driverPhone, data }) => {
  const { licensePlate, carModel, carMake, driverName, carImageUrl } =
    useReceiptCardInfo(data);

  return (
    <div className="w-full flex flex-col items-stretch">
      <div
        className="rounded-lg p-4 flex flex-col gap-2 max-w-full bg-white
        mx-0 mt-0 mb-2
        sm:mx-5 sm:mt-2"
      >
        <div className="flex items-center justify-between">
          <div>
            <div className="text-base inline-block bg-nobel-50 rounded-lg px-2 py-1  font-bold text-mineshaft-900 mb-2">
              {licensePlate}
            </div>

            {(carMake || carModel) && (
              <div className="text-base font-bold text-mineshaft-900">
                {[carMake, carModel].filter(Boolean).join(" ")}
              </div>
            )}

            <div className="text-base font-semibold text-mineshaft-900">
              {driverName}
              {/* &bull;{" "}
              {driverPhone.replace(/^(\+852)(\d+)/, "$1 $2")} */}
            </div>
          </div>

          <img
            src={carImageUrl || "/defaul-taxi-icon.png"}
            alt="Car"
            className="w-20 h-20 object-contain mr-4"
          />
        </div>
      </div>
    </div>
  );
};

export default DriverInfo;
